var efmCart = {};

/* DOM selectors */
var elemHeaderCartToggleButton = document.getElementById('cart-icon-bubble');
var elemUtilityHeaderCartToggleButton = document.getElementById('cart-icon-bubble-utility');
var elemCartDrawerCloseButton = document.getElementById('js-cart-drawer-close');
var elemCartDrawerOverlay = document.getElementById('js-cart-drawer-overlay');
var elemCartDrawer = document.getElementById('js-cart-drawer');

elemCartDrawer.cartNotification = document.querySelector('drawer-cart');

efmCart.openCart = function() {
  document.body.style.overflowY = 'hidden';
  elemCartDrawer.classList.add('animate', 'js-cart-drawer-open');
  elemCartDrawerOverlay.classList.add('animate', 'js-cart-drawer-overlay-open');

  elemCartDrawer.addEventListener('transitionend', () => {
    elemCartDrawer.focus();
    trapFocus(elemCartDrawer,elemCartDrawerCloseButton);
  }, { once: true });
}

efmCart.closeCart = function() {
  document.body.style.overflowY = 'visible';
  elemCartDrawer.classList.remove('js-cart-drawer-open');
  elemCartDrawerOverlay.classList.remove('js-cart-drawer-overlay-open');
  removeTrapFocus();
}

elemCartDrawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && efmCart.closeCart() );

elemHeaderCartToggleButton.addEventListener('click', efmCart.openCart);
elemUtilityHeaderCartToggleButton.addEventListener('click', efmCart.openCart);
elemCartDrawerCloseButton.addEventListener('click', efmCart.closeCart);
elemCartDrawerOverlay.addEventListener('click', efmCart.closeCart);


elemCartDrawer.addEventListener('click',function(e){
  /* add upsell product */
  if (e.target.classList.contains('js-quick-add-product')) {
    quickAddProduct(e.target.dataset.variantId);
  }

  /* add free gift that has only a single variant */
  if (e.target.closest('.js-quick-add-product--free-gift')) {
    let freeGiftLink = e.target.closest('.js-quick-add-product--free-gift');
    freeGiftLink.querySelector('p:last-of-type').style.display = 'none';
    freeGiftLink.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    if (freeGiftLink.dataset.freeGiftAlreadyExists == 'true') {
      removeProductThenAddProduct(freeGiftLink.dataset.freeGiftAlreadyExistsVariantId, freeGiftLink.dataset.variantId);
    } else {
      quickAddProduct(freeGiftLink.dataset.variantId);
    }
 
  }

  /* add free gift that has multiple variants */
  if (e.target.closest('.js-quick-add-product--free-gift-with-options')) {
    let freeGiftLink = e.target.closest('.js-quick-add-product--free-gift-with-options');
    freeGiftLink.style.display = 'none';
    if (freeGiftLink.dataset.freeGiftAlreadyExists == 'true') {
      getFreeGiftOptions(freeGiftLink.dataset.productHandle, true, freeGiftLink.dataset.freeGiftAlreadyExistsVariantId);
    } else {
      getFreeGiftOptions(freeGiftLink.dataset.productHandle, false, '');
    }
  }

  if (e.target.closest('.js-quick-add-product--free-gift-change-options')) {
    let freeGiftLink = e.target.closest('.js-quick-add-product--free-gift-change-options');
    freeGiftLink.style.display = 'none';
    getFreeGiftOptions(freeGiftLink.dataset.productHandle, true, freeGiftLink.dataset.freeGiftAlreadyExistsVariantId);
  }

  if (e.target.classList.contains('js-subscribe-and-save-button')) {
    let currentQuantity = e.target.closest('.cart-item').querySelector('.quantity__input').value;
    let keyToRemove = e.target.closest('.cart-item').dataset.key;
    let variantIdToAdd = e.target.dataset.variantId;
    let sellingPlanIdToAdd = e.target.dataset.defaultSellingPlanId;
    e.target.style.pointerEvents = 'none';
    e.target.style.opacity = '0.5';
    e.target.innerText = 'Upgrading...';
    removeRegularProductThenAddSubscriptionProduct(keyToRemove, variantIdToAdd, currentQuantity, sellingPlanIdToAdd);
  }

});

elemCartDrawer.addEventListener('change', function(e) {
  if (e.target.classList.contains('subscribe-and-save-select')) {
    e.target.parentElement.querySelector('.icon-caret').style.display = 'none';
    e.target.parentElement.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    if (e.target.value == 'onetime') {
      e.target.style.pointerEvents = 'none';
      e.target.style.opacity = '0.5';
      let currentQuantity = e.target.closest('.cart-item').querySelector('.quantity__input').value;
      let variantIdToAdd = e.target.dataset.variantId;
      let keyToRemove = e.target.closest('.cart-item').dataset.key;
      removeSubscriptionProductThenAddRegularProduct(keyToRemove,variantIdToAdd,currentQuantity)
    } else {
      // let lineItemIndexToUpdate = e.target.closest('.cart-item').querySelector('.quantity__input').dataset.index;
      let lineItemIndexToUpdate = e.target.closest('.cart-item').dataset.key;
      let newSellingPlanId = e.target.value;
      let currentQuantity = e.target.closest('.cart-item').querySelector('.quantity__input').value;
      updateSubscriptionInterval(lineItemIndexToUpdate,newSellingPlanId,currentQuantity);
    }
  };
});

function quickAddProduct(variantId,redirectToCheckout) {
  if (redirectToCheckout == undefined) {
    redirectToCheckout = false;
  }
  // console.log(redirectToCheckout);
  var addData = {
    'id':variantId,
    'quantity':1,
    'sections': ['cart-icon-bubble', 'cart-icon-bubble-utility', 'main-cart-items', 'main-cart-footer'],
    'sections_url': '/pages/contact-us'
  };

  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    elemCartDrawer.cartNotification.renderContents(response);
    document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);
    updateDiscountCode();
    customKlaviyoAddToCartEvent(response);
    if (redirectToCheckout == true) {
      document.location.href = '/cart/checkout';
    }
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
}

function quickAddSubscriptionProduct(variantIdToAdd,sellingPlanIdToAdd,redirectToCheckout) {
  var addData = {
    'id':variantIdToAdd,
    'quantity':1,
    'selling_plan': sellingPlanIdToAdd,
    'sections': ['cart-icon-bubble', 'cart-icon-bubble-utility', 'main-cart-items', 'main-cart-footer'],
    'sections_url': '/pages/contact-us'
  };
  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    elemCartDrawer.cartNotification.renderContents(response);
    document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);
    customKlaviyoAddToCartEvent(response);
    if (redirectToCheckout == true) {
      document.location.href = '/cart/checkout';
    }
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
}

function addFreeGiftWithOptions() {
  let variantId = this.options[this.selectedIndex].dataset.variantId;

  var addData = {
    'id':variantId,
    'quantity':1,
    'sections': 'cart-icon-bubble,cart-icon-bubble-utility,main-cart-items,main-cart-footer',
    'sections_url': '/pages/contact-us'
  };

  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    elemCartDrawer.cartNotification.renderContents(response);
    document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);

  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
}

function forceRemoveFreeGift(variantIdToRemove) {
  var addData = {
    'id':variantIdToRemove,
    'quantity':0,
    'sections': ['cart-icon-bubble', 'cart-icon-bubble-utility', 'main-cart-items', 'main-cart-footer'],
    'sections_url': '/pages/contact-us'
  };

  fetch('/cart/change.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    elemCartDrawer.cartNotification.renderContents(response);
    document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });

}

function changeFreeGiftOptions() {
  let oldFreeGiftVariant = this.dataset.freeGiftAlreadyExistsVariantId;
  let newFreeGiftVariant = this.options[this.selectedIndex].dataset.variantId;
  removeProductThenAddProduct(oldFreeGiftVariant, newFreeGiftVariant);
}

function removeProductThenAddProduct(variantIdToRemove,variantIdToAdd) {
  var removeData = {
    'id':variantIdToRemove,
    'quantity':0
  };
  var addData = {
    'id':variantIdToAdd,
    'quantity':1,
    'sections': ['cart-icon-bubble', 'cart-icon-bubble-utility', 'main-cart-items', 'main-cart-footer'],
    'sections_url': '/pages/contact-us'
  };

  fetch('/cart/change.js', {
    body: JSON.stringify(removeData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    })
    .then((response) => response.json())
    .then(function(response) {
      elemCartDrawer.cartNotification.renderContents(response);
      document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
      document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
      document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);
    }).catch(function(err) {
      /* uh oh, we have error. */
      console.error(err)
    });
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });

}

function removeRegularProductThenAddSubscriptionProduct(keyToRemove, variantIdToAdd, currentQuantity, sellingPlanIdToAdd) {
  var removeData = {
    'id':keyToRemove,
    'quantity':0
  };
  var addData = {
    'id':variantIdToAdd,
    'quantity':currentQuantity,
    'selling_plan': sellingPlanIdToAdd,
    'sections': ['cart-icon-bubble', 'cart-icon-bubble-utility', 'main-cart-items', 'main-cart-footer'],
    'sections_url': '/pages/contact-us'
  };

  fetch('/cart/change.js', {
    body: JSON.stringify(removeData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    })
    .then((response) => response.json())
    .then(function(response) {
      elemCartDrawer.cartNotification.renderContents(response);
      document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
      document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
      document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);
    }).catch(function(err) {
      /* uh oh, we have error. */
      console.error(err)
    });
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });

}

function removeSubscriptionProductThenAddRegularProduct(keyToRemove,variantIdToAdd,currentQuantity) {
  var removeData = {
    'id':keyToRemove,
    'quantity':0
  };
  var addData = {
    'id':variantIdToAdd,
    'quantity':currentQuantity,
    'sections': ['cart-icon-bubble', 'cart-icon-bubble-utility', 'main-cart-items', 'main-cart-footer'],
    'sections_url': '/pages/contact-us'
  };

  fetch('/cart/change.js', {
    body: JSON.stringify(removeData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    })
    .then((response) => response.json())
    .then(function(response) {
      elemCartDrawer.cartNotification.renderContents(response);
      document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
      document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
      document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);
    }).catch(function(err) {
      /* uh oh, we have error. */
      console.error(err)
    });
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });

}

function updateSubscriptionInterval(lineItemIndexToUpdate,newSellingPlanId,currentQuantity) {
  var addData = {
    'id':lineItemIndexToUpdate,
    'quantity':currentQuantity,
    'selling_plan':newSellingPlanId,
    'sections': ['cart-icon-bubble', 'cart-icon-bubble-utility', 'main-cart-items', 'main-cart-footer'],
    'sections_url': '/pages/contact-us'
  };

  fetch('/cart/change.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => response.json())
  .then(function(response) {
    elemCartDrawer.cartNotification.renderContents(response);
    document.querySelector('cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-items').classList.toggle('is-empty', response.item_count === 0);
    document.getElementById('main-cart-footer-insert').classList.toggle('is-empty', response.item_count === 0);
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });

}

function checkFreeGifts() {
  var freeGiftRemoveElem = document.getElementById("js-triggers-force-remove-free-gift");
  if (freeGiftRemoveElem) {
    var variantIdToRemove = freeGiftRemoveElem.dataset.freeGiftVariantId;
    forceRemoveFreeGift(variantIdToRemove);
  }
}


function getFreeGiftOptions(freeGiftProductHandle, freeGiftAlreadyExists, freeGiftAlreadyExistsVariantId) {

  fetch(`/products/${freeGiftProductHandle}.js`)
  .then((response) => response.json())
  .then(function(data) {
    /*
      <div>
        <label class="form__label">option.name</label>
        <div class="select">
          <select>
            <option></option>
          </select>
        </div>
      </div>
    */

    /* create the HTML structure in a document fragment */

    var placeholderDiv = document.getElementById('js-free-gift-options-placeholder-' + freeGiftProductHandle);
    var fragment = new DocumentFragment();

    var optionName = data.options[0].name;

    var fragmentOuterDiv = document.createElement('div');
    var fragmentLabel = document.createElement('label');
    fragmentLabel.classList.add('form__label');
    fragmentLabel.innerHTML = 'Select ' + optionName;
    fragmentLabel.htmlFor = freeGiftProductHandle + '-' + optionName;
    fragmentOuterDiv.appendChild(fragmentLabel);

    var fragmentInnerDiv = document.createElement('div');
    fragmentInnerDiv.classList.add('select');

    var fragmentSelect = document.createElement('select');
    fragmentSelect.id = freeGiftProductHandle + '-' + optionName;
    fragmentSelect.classList.add('select__select');

    if (freeGiftAlreadyExistsVariantId.length > 0) {
      fragmentSelect.dataset.freeGiftAlreadyExistsVariantId = freeGiftAlreadyExistsVariantId;
    }

    if (freeGiftAlreadyExists == true) {
      fragmentSelect.onchange = changeFreeGiftOptions;
    } else {
      fragmentSelect.onchange = addFreeGiftWithOptions;
    }

    var fragmentOptionDisabled = document.createElement('option');
    fragmentOptionDisabled.innerHTML = '-- Choose Option --';
    fragmentOptionDisabled.value = '';
    fragmentOptionDisabled.disabled = true;
    fragmentOptionDisabled.setAttribute('selected',true);
    fragmentSelect.appendChild(fragmentOptionDisabled);

    data.variants.forEach(function(variant) {
      if (variant.available) {
        var fragmentOption = document.createElement('option');
        fragmentOption.value = variant.title;
        fragmentOption.dataset.variantId = variant.id;
        fragmentOption.innerHTML = variant.title;
        fragmentSelect.appendChild(fragmentOption);
      } else {
        var fragmentOption = document.createElement('option');
        fragmentOption.value = variant.title;
        fragmentOption.disabled = true;
        fragmentOption.dataset.variantId = variant.id;
        fragmentOption.innerHTML = variant.title + ' (Out of Stock)';
        fragmentSelect.appendChild(fragmentOption);
      }
    });

    var svgIcon = `<svg  fill="none">
                   <path d="" fill="currentColor"></path>
                   </svg>`;

    fragmentInnerDiv.appendChild(fragmentSelect);
    placeholderDiv.parentElement.style.display = 'flex';

    /*
      create svg caret icon

      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 36 36" fill="none">
      <path d="M9.115 12L18 20.87L26.885 12L29 14.115L18 25.115L7 14.115L9.115 12Z" fill="currentColor"></path>
      </svg>
    */

    const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const iconPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );

    iconSvg.setAttribute('aria-hidden', 'true');
    iconSvg.setAttribute('focusable', 'false');
    iconSvg.setAttribute('role', 'presentation');
    iconSvg.setAttribute('viewBox', '0 0 36 36');
    iconSvg.setAttribute('fill', 'none');
    iconSvg.classList.add('icon','icon-caret');

    iconPath.setAttribute(
      'd',
      'M9.115 12L18 20.87L26.885 12L29 14.115L18 25.115L7 14.115L9.115 12Z'
    );
    iconPath.setAttribute('fill', 'currentColor');

    iconSvg.appendChild(iconPath);

    fragmentInnerDiv.appendChild(iconSvg);
    fragmentOuterDiv.appendChild(fragmentInnerDiv);

    fragment.appendChild(fragmentOuterDiv);

    /* insert the document fragment into drawer cart */
    placeholderDiv.appendChild(fragment);

  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });

}